export const PARTY_OUTSTANDING_REPORT_GO_BUTTON_API = 'PARTY_OUTSTANDING_REPORT_GO_BUTTON_API'
export const PARTY_OUTSTANDING_REPORT_GO_BUTTON_API_SUCCESS = 'PARTY_OUTSTANDING_REPORT_GO_BUTTON_API_SUCCESS'

export const PARTY_OUTSTANDING_REPORT_API_ERROR_ACTION = 'PARTY_OUTSTANDING_REPORT_API_ERROR_ACTION'